import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = (response, context) => {
    context.rentals = response.data.rentals;
    context.environmentData = response.data.environmentData;
    context.netatmoConfiguredForRental = response.data.netatmoConfiguredForRental;
    context.userHaveConfiguredNetatmo = response.data.userHaveConfiguredNetatmo;

    if(context.userHaveConfiguredNetatmo && context.netatmoConfiguredForRental && !context.alreadyRendered){
        context.generateDataForEnvironmentCharts(context.environmentData);
        if(context.noiseSoundChartData.length > 0 || context.coChartData.length > 0 || context.tempChartData.length > 0){
            // vm.environmentNotConfigured = false;
            context.alreadyRendered = true;
            context.renderTempCharts(context.tempChartData);
            context.renderCOCharts(context.coChartData);
            context.renderNoiseSoundCharts(context.noiseSoundChartData);
        }else {
            // vm.environmentNotConfigured = true;
        }
    }else if(context.userHaveConfiguredNetatmo && context.netatmoConfiguredForRental && context.alreadyRendered){
        context.generateDataForEnvironmentCharts(context.environmentData);
        context.updateCharts(context.chartTemp, context.ctxTemp, context.tempChartData);
        context.updateCharts(context.chartNoiseSound, context.ctxNoiseSound, context.noiseSoundChartData);
        context.updateCharts(context.chartCO, context.ctxCO, context.coChartData);
    }

    context.loading = false;
    return response.data;
};

// When the request fails
const failed = (error, context) => {
    context.loading = false;
    toastr.error(context.$t('analytics.index.environment_retrieving_failed'));
    // context.showToasterError(error);
};

export default (url, context) => {
    return Vue.$http.get(url)
        .then((response) => {
            if (response.status === 200) {
                success(response, context);
            }
        })
        .catch((error) => {
            failed(error, context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/analytics/getEnvironmentTab.js